var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowingIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7233 26.3951L6.02205 45.0111C5.71309 45.618 5.18296 46.083 4.54114 46.3101C3.89932 46.5372 3.19484 46.509 2.57318 46.2314C1.95153 45.9538 1.46018 45.4479 1.20061 44.8183C0.94104 44.1887 0.933083 43.4834 1.17838 42.848L16.319 14.4568V9.72414C15.605 9.02203 15.1055 8.13116 14.8787 7.15561C14.6519 6.18006 14.7072 5.1601 15.0383 4.21484C15.4835 3.23959 16.204 2.4158 17.111 1.8448C18.0181 1.27381 19.0722 0.980519 20.1437 1.001H21.3059C21.9481 1.00098 22.5841 1.12751 23.1774 1.37338C23.7708 1.61924 24.3099 1.97961 24.764 2.43393C25.2181 2.88826 25.5784 3.42763 25.8241 4.02123C26.0699 4.61484 26.1963 5.25107 26.1963 5.89358V11.2183L23.1275 12.9211",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.448 67.4132V51.556L26.4463 38.4643L24.7441 18.0298",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4258 74.2248L23.1279 48.6816H24.7994L31.6913 55.4931L31.6385 72.5219H40.1492",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6172 33.3555V79.3331H24.83",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.999 58.8989H65.6799V65.7104H48.6586V72.5219H31.6373V79.3334H2.70117",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.958 12.9214H38.4473V16.221L43.5536 26.864L38.4473 36.9751V40.1674H62.2771C63.1799 40.1674 64.0458 39.8086 64.6842 39.1699C65.3227 38.5312 65.6813 37.6649 65.6813 36.7617C65.6813 35.8584 65.3227 34.9921 64.6842 34.3534C64.0458 33.7147 63.1799 33.3559 62.2771 33.3559H55.4686C54.5657 33.3559 53.6998 32.9971 53.0614 32.3584C52.423 31.7197 52.0643 30.8534 52.0643 29.9501C52.0643 29.0469 52.423 28.1806 53.0614 27.5419C53.6998 26.9032 54.5657 26.5444 55.4686 26.5444H79.2983",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2985 58.8988V1.00098H55.4687C54.5658 1.00098 53.7 1.35979 53.0615 1.9985C52.4231 2.6372 52.0645 3.50347 52.0645 4.40673V29.9499",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6816 36.7612V26.5439",
    stroke: "#EEEBE7",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowingIco);
export default __webpack_public_path__ + "static/media/growing-ico.778925aa5c0e5f61514524b8f13aabfa.svg";
export { ForwardRef as ReactComponent };